import { defineStore } from 'pinia'
import { sendApi } from '@/utils/api'
function dataRender (data){
  return data.map(item => ({
    id: item.id,
    title: item.title,
    description: item.description,
    self : item.self??false,
    filter: Array.isArray(item.filter)
      ? item.filter.map(f => ({
        id: f.id,
        city: f.city
      })):[],
    like: item.like,
    call: item.call,
    chat: item.chat,
    created_at: item.created_at,
    deleted_at: item.deleted_at,
    location: {
      city: item.city || null,
      lat: item.address_lat || null,
      lon: item.address_lon || null,
      address: item.address || null,
    },
    category: Array.isArray(item.category)
      ? item.category.map(c => ({
          id: c.id,
          title: c.title
        }))
      : [],
    user: {
      id: item.user_account_id || null,
      name: item.user_name || '',
      family: item.user_family || '',
      phone: item.user_phone || '',
      image: item.user_image_url || null,
    },
    medias: Array.isArray(item.media)
      ? item.media.map(m => ({
          id: m.id,
          type: m.type,
          url: m.url
        }))
      : []
  }));
}
export const useProductStore = defineStore('product', {
  state: () => ({
    cards: [],
    hasMore: false,
    isLoaded: false,
    manageCards: [],
    manageHasMore: false,
    manageIsLoaded: false,
    reactionCards: [],
    reactionHasMore: false,
    reactionIsLoaded: false,
  }),
  actions: {
    async fetchProduct (limit = 10, offset = 0, append = false) {
      try{
        const res = await sendApi({
          action: 'get_product',
          control: 'product',
          data: { limit, offset }
        })
        if (res.status === 'success') {
          const newproducts = dataRender(res.data);
          const filteredproducts = newproducts.filter(product => product.id)
          if(append){
            this.cards = [...this.cards, ...filteredproducts]
          }
          this.isLoaded = true
          this.hasMore = res.has_more ?? false
          return filteredproducts
        }
        return []
      } catch (err) {
        console.log(err);
      }
    },
    async fetchProductById (id) {
      try{
        const res = await sendApi({
          action: 'get_product_by_id',
          control: 'product',
          data: { id }
        })
        if (res.status === 'success') {
          const item = [];
          item[0]=res.data;
          return dataRender(item);
        }
        return null
      } catch (err) {
        console.log(err);
      }
    },
    async addProductChatForward (id) {
      try{
        const res = await sendApi({
          action: 'user_product_action',
          control: 'product',
          data: { id:id,action:'chatForward' }
        })
        if (res.status === 'success') {
          this.cards.map( (p) => {
            if(p.id === id) { 
              p.chat = 'yes'
            }
          });
        }
      } catch (err) {
        console.log(err);
      }
    },



    async addProductForward (id) {
      try{
        const res = await sendApi({
          action: 'user_product_action',
          control: 'product',
          data: { id:id,action:'forward' }
          // to user must be send 
        })
        if (res.status === 'success') {
          this.cards.map( (p) => {
            if(p.id === id) { 
              p.chat = 'yes'
            }
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async addProductChat (id) {
      try{
        const res = await sendApi({
          action: 'user_product_action',
          control: 'product',
          data: { id:id,action:'chat' }
        })
        if (res.status === 'success') {
          this.cards.map( (p) => {
            if(p.id === id) { 
              p.chat = 'yes'
            }
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async addProductCall (id) {
      try{
        const res = await sendApi({
          action: 'user_product_action',
          control: 'product',
          data: { id:id,action:'call' }
        })
        if (res.status === 'success') {
          this.cards.map( (p) => {
            if(p.id === id) { 
              p.call = 'yes'
            }
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async addProductLike (id) {
      try{
        const res = await sendApi({
          action: 'user_product_action',
          control: 'product',
          data: { id:id,action:'like' }
        })
        if (res.status === 'success') {
          this.cards.map( (p) => {
            if(p.id === id) { 
              p.like = 'yes'
            }
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async productDisLike (id) {
      try{
        const res = await sendApi({
          action: 'user_product_action',
          control: 'product',
          data: { id : id , action:'disLike' }
        })
        if (res.status === 'success') {
          this.cards.map( (p) => {
            if(p.id === id) { 
              p.like = 'no'
            }
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async addProductData () {
      try{
        const data = await sendApi({ control: 'product', action: 'add_data' })
        if (data.status === 'success') {
          return {category:data.category ?? [],city:[...data.city] ?? []}
        }
      }catch(err){
        console.error(err)
      }
    },
    async addProduct (data){
      try {
        const res = await sendApi({
          control: 'product',
          action: 'add_product',
          data: data,
        })
        return res.status === 'success';
      } catch (err) {
        console.error('خطا در ارسال: ' + err.message)
      }
    },
    async editProduct (data){
      try {
        const res = await sendApi({
          control: 'product',
          action: 'edit_product',
          data: data,
        })
        return res.status === 'success';
      } catch (err) {
        console.error('خطا در ارسال: ' + err.message)
      }
    },
    async deleteProduct (id){
      try {
        const res = await sendApi({
          control: 'product',
          action: 'delete_product_action',
          data: {id:id,action:'delete'},
        })
        return res.status === 'success';
      } catch (err) {
        console.error('خطا در ارسال: ' + err.message)
      }
    },
    async restoreProduct (id){
      try {
        const res = await sendApi({
          control: 'product',
          action: 'delete_product_action',
          data: {id:id,action:'restore'},
        })
        return res.status === 'success';
      } catch (err) {
        console.error('خطا در ارسال: ' + err.message)
      }
    },
    async fetchManageProduct (limit = 10, offset = 0, append = false) {
      try {
        const res = await sendApi({ 
          control: 'product',
          action: 'user_product',
          data: { limit, offset }
        })
        if (res.status === 'success') {
          const newproducts = dataRender(res.data);
          const filteredproducts = newproducts.filter(product => product.id)
          if(append){
            this.manageCards = [...this.manageCards, ...filteredproducts]
          }
          this.manageIsLoaded = true
          this.manageHasMore = res.has_more ?? false
          return filteredproducts
        }
        return []
      } catch (error) {
        console.error('خطا در ارسال: ' + error.message)
      }
    },
    async fetchProductReaction (limit = 10, offset = 0, append = false) {
      try{
        const res = await sendApi({
          action: 'user_product_reaction_store',
          control: 'product',
          data: { limit, offset }
        })
        if (res.status === 'success') {
          const newproducts = dataRender(res.data);
          const filteredproducts = newproducts.filter(product => product.id)
          if(append){
            this.reactionCards = [...this.reactionCards, ...filteredproducts]
          }
          this.reactionIsLoaded = true
          this.reactionHasMore = res.has_more ?? false
          return filteredproducts
        }
        return []
      } catch (err) {
        console.log(err);
      }
    },
  }
})